import React from 'react';
import { commmonStyles as styles } from 'components/commonStyles';

export interface AnnounceProps {
	message?: string
}

export const Announce = ({ message }: AnnounceProps) => (
	<div
		id='announce'
		aria-live='assertive'
		className={styles.visuallyHidden}
	>
		<p>{message}</p>
	</div>
);

Announce.defaultProps = {
	message: ''
};
